import { lazy } from 'react'

import { BASE_URL } from '../constants'

const SearchHomeScreen = lazy(() => import(/* webpackChunkName: 'search' */ '../screens/Home'))

export default [
  {
    component: SearchHomeScreen,
    path: BASE_URL,
  },
]
